import './TermsClosurePage.css';

const TermsClosurePage = () => {
  const lastUpdated = "18 de Setembro de 2025";

  return (
    <div className="terms-page">
      <header className="header">
        <div className="terms-page-header-container">
          <div className="logo-container">
            <img src='/logo.png' alt="" />
          </div>
          <nav className="header-nav">
            <a href="/" className="nav-link">← Voltar</a>
          </nav>
        </div>
      </header>

      <section className="page-title">
        <div className="terms-page-title-container">
          <h1>Termos para Encerramento de Conta</h1>
          <p className="subtitle">Última atualização: {lastUpdated}</p>
        </div>
      </section>

      <main className="main-content">
        <div className="terms-page-content-container">
          <div className="content">

            <div className="warning-box">
              <div className="warning-icon">⚠️</div>
              <div>
                <h3>Importante!</h3>
                <p>O encerramento da conta é irreversível e todos os dados serão permanentemente excluídos.</p>
              </div>
            </div>

            <section className="section">
              <h2>Como funciona o processo</h2>
              <div className="steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Solicitação</h4>
                    <p>Faça a solicitação através do formulário em sua conta</p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Processamento</h4>
                    <p>Encerramento processado em até 24 horas úteis</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="section">
              <h2>O que acontece com seus dados</h2>
              <div className="info-grid">
                <div className="info-card">
                  <h4>🗑️ Exclusão completa</h4>
                  <p>Todos os dados pessoais são permanentemente excluídos em até 30 dias</p>
                </div>
                <div className="info-card">
                  <h4>📋 Dados legais</h4>
                  <p>Apenas dados exigidos por lei são mantidos pelo período mínimo legal</p>
                </div>
                <div className="info-card">
                  <h4>🔒 Segurança</h4>
                  <p>Durante o processo, seus dados permanecem seguros e criptografados</p>
                </div>
              </div>
            </section>

            <section className="section">
              <h2>Consequências do encerramento</h2>
              
              <h4>Você perderá acesso a:</h4>
              <ul className="simple-list negative">
                <li>Sua conta e todos os dados salvos</li>
                <li>Histórico de atividades e configurações</li>
                <li>Assinaturas e serviços ativos</li>
                <li>Possibilidade de recuperar informações</li>
              </ul>

              <h4>O que será feito:</h4>
              <ul className="simple-list positive">
                <li>Cessação de todas as comunicações</li>
                <li>Cancelamento de cobranças futuras</li>
                <li>Reembolso proporcional quando aplicável</li>
                <li>Confirmação do encerramento por email</li>
              </ul>
            </section>

            <section className="section">
              <h2>Quando o encerramento pode ser adiado</h2>
              <div className="exception-list">
                <div className="exception-item">
                  <strong>Investigações em andamento:</strong> Contas sob investigação podem ter o encerramento postergado
                </div>
                <div className="exception-item">
                  <strong>Pendências financeiras:</strong> Débitos ou questões contratuais devem ser resolvidos primeiro
                </div>
                <div className="exception-item">
                  <strong>Questões legais:</strong> Ordens judiciais podem impedir o encerramento temporariamente
                </div>
              </div>
            </section>

            <div className="confirmation-box">
              <h3>Ao solicitar o encerramento da conta, você confirma que:</h3>
              <ul>
                <li>Leu e compreendeu todos os termos acima</li>
                <li>Entende que a ação é irreversível</li>
                <li>Concorda com a exclusão permanente dos dados</li>
                <li>Não possui pendências que impeçam o encerramento</li>
              </ul>
            </div>

          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="terms-page-footer-container">
          <p>&copy; 2025 Sua Empresa. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsClosurePage;